import React from 'react'
import Svg from './Svg'
export const SvgArrowDown = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path stroke="inherit" strokeMiterlimit={10} d="M23.545 6.203L11.772 17.974 0 6.203" />
  </Svg>
))
SvgArrowDown.isIcon = true
export default SvgArrowDown
